/**
 * TanStack Router: /vacation/request
 *
 * This route file was auto-generated by the route generation script.
 * Component: VacationRequestPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import VacationRequestPage from '@/app/vacation/request/page'

/**
 * Route: /vacation/request
 * Layout: _auth (authenticated)
 * Component: VacationRequestPage
 */
export const Route = createFileRoute('/_auth/vacation/request')({
  component: VacationRequestPage,
})
